export default __webpack_public_path__ + "static/media/img_7.c47601c1.jpg";